import { PlaceholderPage } from './PlaceholderPage';

export const RulePage = () => <PlaceholderPage title="Rule" />;
